import {Box, type BoxProps, Typography} from '@mui/material';
import React from 'react';

export type SectionProps = Omit<BoxProps, 'title'> & {
  /** The h2 that names the region. */
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  /** The h2's id, for a control inside that the title names. */
  titleId?: string;
};

/** A titled block of a page: <section> named by its h2. */
export const Section = ({
  title,
  actions,
  children,
  titleId,
  ...rest
}: SectionProps) => {
  const generatedId = React.useId();
  const id = titleId ?? generatedId;
  return (
    <Box component="section" aria-labelledby={id} {...rest}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          mb: 1.5,
        }}>
        <Typography
          id={id}
          variant="title"
          component="h2"
          sx={{color: 'text.primary'}}>
          {title}
        </Typography>
        {actions && <Box sx={{display: 'flex', gap: 1}}>{actions}</Box>}
      </Box>
      {children}
    </Box>
  );
};
